import { CombineIcon } from 'lucide-react'

import { ProjectStatusBadge } from '@/modules/projects'
import { isProjectStatus } from '../status'
import type { Project } from '../stores'

interface ProjectAssemblingProps {
  project: Project
}

export const ProjectAssembling = ({ project }: ProjectAssemblingProps) => (
  <output className="flex w-full flex-col items-center justify-center gap-4 rounded-lg border py-24 text-center bg-white">
    <div className="rounded-full bg-blue-50 p-4">
      <CombineIcon className="size-8 text-blue-700" />
    </div>
    <div className="space-y-2">
      <h3 className="text-lg font-semibold">
        {isProjectStatus(project, 'duplicating')
          ? 'Duplicating project'
          : 'Combining projects'}
      </h3>
      <p className="text-sm text-muted-foreground">
        This can take a few minutes. The page updates on its own when it is
        ready.
      </p>
    </div>
    <ProjectStatusBadge status={project.status} />
  </output>
)
